<template>
    <div>
        <breadcrumb :routerList="[{to:'/moneyBack_domestic_list',title:'回款管理'},{title:'订单回款'}]"/>
        <div class="h-content">
            <div class="h-piece" style="display: none;">
                <div class="h-formBox Tiem">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
                        <el-form-item label="客户名称">
                            <el-input style="width:1.5rem" v-model="formInline.receUsername" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="回款时间">
<!--                            <el-col :span="11">-->
<!--                                <el-date-picker :clearable="false" v-model="formInline.startReceDate" type="date" placeholder="选择时间" style="width: 1.8rem;"></el-date-picker>-->
<!--                            </el-col>-->
<!--                            <el-col class="line h-txtCenter" :span="2">至</el-col>-->
<!--                            <el-col :span="11">-->
<!--                                <el-date-picker :clearable="false" v-model="formInline.endReceDate" type="date" placeholder="选择时间" style="width: 1.8rem;"></el-date-picker>-->
<!--                            </el-col>-->
                            <el-date-picker
                                    @change="timeSelect"
                                    v-model="value2"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="回款类型">
                            <el-select placeholder="请选择" style="width:1.3rem" v-model="formInline.receMark">
                                <el-option label="预付款" value="1"></el-option>
                                <el-option label="赊销回款" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="h-formBtnOut">
                            <el-button class="h-btn h-formBtn" @click="searchReset">检索</el-button>
                            <el-button class="h-btn h-formBtn" @click="resetData" style="background-color:white;color:black;border:1px solid #d1d1d1">重置</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="h-table h-mrt30">
                <el-table
                        ref="multipleTable"
                        @selection-change="handleSelectionChange"
                        :data="tableData2.records"
                        stripe
                        style="width: 100%"
						:border="true"
						max-height="510"
                >
                    <el-table-column
                            type="selection"
                            width="55"
                            label="全选"
                    >
                    </el-table-column>
                    <el-table-column
                            fixed
                            type="index"
                            label="#"
                            width="40">
                    </el-table-column>
                    <el-table-column
                            prop="id"
                            sortable
                            label="回款编号"
							:show-overflow-tooltip="true"
                            width="200">
                    </el-table-column>
                    <el-table-column
                            prop="receUsername"
                            label="客户名称"
							:show-overflow-tooltip="true"
                            >
							<template slot-scope="scope">
								<div style="text-align: left;">
									{{scope.row.receUsername}}
								</div>
							</template>
                    </el-table-column>
                    <el-table-column
                            prop="bukrs"
                            label="公司代码"
							:show-overflow-tooltip="true"
                            width="140">
<!--                        <template slot-scope="scope">-->
<!--                            <dictname category="credit_type" :v="scope.row.receMark"/>-->
<!--                        </template>-->
                    </el-table-column>
                    <el-table-column
                            prop="wrbtr"
                            label="回款金额"
                            width="140">
                    </el-table-column>
                    <el-table-column
                            prop="budat"
                            label="回款时间"
                            width="220">
                    </el-table-column>

                    <el-table-column
                            label="操作"
							width="100"
                            fixed="right"
                    >
                        <template slot-scope="scope">
                            <el-button
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                            @click="showDetail(scope.row)">
                                查看
                            </el-button>
							<!-- <div class="l-operationBox">
								<span class="l-operationlist br-operation-look" title="查看" @click="showDetail(scope.row)"></span>
							</div> -->
                        </template>
                    </el-table-column>
                </el-table>
                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL" style="display:none">
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="downloadExcel">批量导出</el-button>
                    </div>
                    <div class="h-pagination2">
                        <pagination :page="q" @query="choose"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ss from '../../../api/SystemService'

    export default {
        name: 'leftMenu',
        data() {
            return {
                value2: '',
                page: {},
                q: {
                    // codeLikenameLike: null,
                    // categoryLikecatenameLike: null,
                    // delflag: null,
                    pageSize:10,
                    pageNo:1,
                    total:0
                },
                //表单
                formInline: {
                    receUsername:'',
                    startReceDate:'',
                    endReceDate:'',
                    receMark:'',
                    pageSize:10,
                    pageNo:1,
                },
                //表格
                multipleSelection: [],
                tableData2: [],
                flag: 0,
                //弹框
                dialogFormVisible: false,
                formLabelAlign2: {
                    id: null,
                    cucode: null,
                    cuname: null,
                    cdate: null,
                    lucode: null,
                    ldate: null,
                    delflag: null,
                    receUsercode: null,
                    receUsername: null,
                    receMark: null,
                    receAmount: null,
                    receCurrency: null,
                    receCertNumber: null,
                    receBank: null,
                    receDate: null,
                    remark: null
                },
                checkboxGroup1: ['亚太'],
                cities: ['非洲', '亚太', 'UN']
            }
        },

        created() {
            this.query();
        },
        methods: {
            timeSelect(){
                this.formInline.startReceDate = this.value2[0];
                this.formInline.endReceDate = this.value2[1];
            },
            choose(){
              if (this.flag===1){
                  this.search();
              }  else{
                  this.query();
              }
            },
            searchReset(){
                this.q.pageNo=1;
                this.search();
            },
            //根据条件检索
            search(){
                // console.log(this.formInline)
                this.formInline.pageNo = this.q.pageNo;
                this.formInline.pageSize = this.q.pageSize;
                ss.moneyBackDomesticService.search(this.formInline).then(rd =>{
                    this.q.total=rd.total;
                    // console.log(rd);
                    this.tableData2 = rd;
                    this.flag = 1;

                    // console.log(this.tableData2)
                })
            },
            // 查询内销回款分页列表
            query() {
                ss.moneyBackDomesticService.query(this.q).then(rd => {
                    this.q.total=rd.total;
                    console.log(rd);
                    this.tableData2 = rd;
                })
            },
            //表格
            handleSelectionChange(val) {
                this.multipleSelection = val;
                // console.log(this.multipleSelection,'1111111')
            },
            showDetail(data){
                this.$router.push({path: "/moneyBack_detail", query: data});
                // console.log(data)
            },
            downloadExcel(){
                //ids
                var cc = [];
                for (var d in this.tableData2.records.id) {
                    cc.push(this.tableData2.records[d].id);
                }
                //查询参数
                var c = {
                    ids: cc,
                };
                ss.moneyBackDomesticService.downloadExcel(c);
            },
            //重置检索项
            resetData(){
                this.value2 = '';
                this.formInline.receUsername = '';
                this.formInline.startReceDate = '';
                this.formInline.endReceDate = '';
                this.formInline.receMark = '';
                this.formInline.pageSize = 10;
                this.formInline.pageNo = 1;
                this.flag = 0;
                this.q.pageSize = 10;
                this.q.pageNo = 1;
                this.q.total = 0;
                this.query();
            },
        }
    }
</script>
<style>
    .Tiem .el-date-editor .el-range-separator{
        width: 9%;
        line-height: 0.35rem;
    }
    .Tiem .h-formBorder .el-form-item__label{
        vertical-align: top;
    }
</style>
